export default function GeneratingLoader({ message = "Creating something magical..." }) {
  return (
    <div
      className="flex flex-col items-center justify-center py-10 px-4"
      data-testid="generating-loader"
    >
      <div className="relative w-full max-w-[280px] overflow-hidden mb-5">
        {/* Running track */}
        <div className="h-1 w-full bg-border-pink rounded-full mb-4 overflow-hidden">
          <div className="h-full bg-blush rounded-full animate-gen-progress" />
        </div>
        {/* Running puppy */}
        <div className="animate-gen-run">
          <img
            src="/running-pom.png"
            alt="Loading..."
            className="w-20 h-auto drop-shadow-sm"
          />
        </div>
      </div>
      <p className="text-text-secondary text-sm text-center font-sans animate-pulse">
        {message}
      </p>
      <div className="flex gap-1.5 mt-3">
        {[0, 1, 2].map((i) => (
          <span
            key={i}
            className="w-1.5 h-1.5 rounded-full bg-blush animate-gen-dots"
            style={{ animationDelay: `${i * 0.3}s` }}
          />
        ))}
      </div>
    </div>
  );
}
